import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ContactService } from '../../services/index';
import { Contact } from '../../models/index';

import { LazyLoadEvent } from 'primeng/primeng';

@Component({
  selector: 'contact-select-dialog',
  templateUrl: './contact-select-dialog.component.html',
  styleUrls: ['./contact-select-dialog.component.scss'],
  animations: []
})
export class ContactSelectDialogComponent {
    @Input()  private button: string = '';
    @Input()  private closeOnSelect: boolean = true;
	@Input()  private disabled: boolean = false;
    @Input()  private contactId: number;
    @Output() private onSelect: EventEmitter<Contact> = new EventEmitter();
    
    private isOpen: boolean = false;

	private contacts: Contact[] = [];
	private totalContacts: number = 0;
	private lastEvent: LazyLoadEvent;
    
    constructor(private contactService: ContactService) { }

    private onRowSelect(event)
    {
        let contact: Contact = event.data;
        
        this.onSelect.emit(contact);

        if (this.closeOnSelect) {
            this.close();
        }
    }

    open()
    {
        this.isOpen = true;
        this.loadContacts();
    }

    close()
    {
        this.isOpen = false;
    }
    
	loadContacts(event?: any) {
		if (!event) {
			event = this.lastEvent;
		}

		if (!event) {
			return;
		} else {
			this.lastEvent = event;
		}

		if (!this.isOpen) {
			return;
		}

        if (this.contactId) {
            event.contact_id = this.contactId;
        }

		this.contactService.getLazy(event).subscribe(data => {
			this.contacts = data.data;
			this.totalContacts = data.total;
		}, err => {
		});
	}

}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/modules/contact-select-dialog/contact-select-dialog.component.ts